import React from 'react';
import { AppImage } from '../AppImage';
import { Reveal } from '../Reveal';
import type { CaseStudyChapter } from '../../types/content';
interface ChapterImage {
  image: string;
  alt: string;
}
interface ChapterProps {
  chapter: CaseStudyChapter;
  id: string;
  image: ChapterImage;
}
export function Chapter({
  chapter,
  id,
  image
}: ChapterProps) {
  return <Reveal data-id="element-166" data-mp="33v5x1kqkzh9d">
      <h2 id={id} className="max-w-[18ch] text-[32px] leading-[1.1] tracking-[-0.03em] text-ink lg:text-[40px]" data-id="element-167" data-mp="3im4xg8h9izhv">
        {chapter.heading}
      </h2>
      <div className="mt-8 space-y-6" data-id="element-168" data-mp="3dmsa7mmhbqer">
        {chapter.paragraphs.map(paragraph => <p key={paragraph.slice(0, 40)} className="max-w-measure text-body text-muted" data-id="element-169" data-mp="3rm1tiv5zf0my">
            {paragraph}
          </p>)}
      </div>
      <AppImage src={image.image} alt={image.alt} ratio="4:3" className="mt-10 lg:mt-12" data-id="element-170" data-mp="1x8aax65od6fd" />
    </Reveal>;
}